<template>
  <div>
    <div class="main">
      <div class="breadcrumb">
        <span
          class="crumb"
          @click="
            $router.push({ path: '/' });
            resetSetItem('isActive', 0);
          "
          >首页</span
        >
        <span>></span>
        <span>作者</span>
        <span>></span>
        <span>{{ laberInfo.name }}</span>
      </div>
      <div class="main-content">
        <div class="content-l">
          <div class="content-list">
            <div
              v-for="(item, index) in list"
              :key="index"
              class="bigBox"
              @click="articlesDetail(item)"
            >
              <div class="list-box">
                <div class="img">
                  <img :src="item.cover_url" alt v-if="typeof item.cover_url == 'string'"/>
                   <img :src="item.cover_url[0]" alt v-else />
                </div>
                <div class="suggest">
                  <p>{{ item.title }}</p>
                  <div class="message">
                    <div>
                      {{ item.visit_times }}
                      <span>阅读</span>
                    </div>
                    <div class="time">
                      {{ item.display_time | timefilters }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="morePage" v-if="show_page">
            <div @click="moreData">
              <p>加载更多</p>
              <div>
                <img src="@/assets/img/more.png" alt />
              </div>
            </div>
          </div>
        </div>
        <div class="content-r">
          <div class="right-box">
            <div class="top-laber">
              <p class="tit">作者信息</p>
              <div class="laber-info">
                <div class="img">
                  <img :src="laberInfo.avatar" alt />
                </div>
                <h4>{{ laberInfo.name }}</h4>
                <div>
                  <span>{{ laberInfo.articles_count }}篇文章</span>
                  <span>{{ laberInfo.followers_count }}人关注</span>
                </div>
                <div class="intro" v-if="laberInfo.introduction">
                  简介：{{ laberInfo.introduction }}
                </div>
                <el-button
                  :class="laberInfo.follow == 'undefined' ? '' : 'isActice'"
                  v-if="laberInfo.follow"
                  @click="cancelAttention(laberInfo.id)"
                  >已关注</el-button
                >
                <el-button
                  :class="laberInfo.follow == 'undefined' ? 'isActice' : ''"
                  v-else
                  @click="attention(laberInfo.id)"
                  >关注</el-button
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <LoginDialog
      :loginDialogs="loginDialogs"
      @child-event="getParentEvent"
    ></LoginDialog>
  </div>
</template>
<script>
import {
  getArthorDetail,
  getCancelAttention,
  getAttention,
  getAuthorArticleList
} from "@/api/public";
import LoginDialog from "@/components/loginDialog";
import { getTdkList} from "@/api/tdk";

export default {
  components: {
    LoginDialog
  },
  data() {
    return {
      page: 1,
      per: 8,
      show_page: true,
      id: "",
      authorName: "李梦雨",
      list: [],
      laberInfo: {},
      loginDialogs: false
    };
  },
  methods: {
    //
    getAuthor(id) {
      getArthorDetail(id).then(res => {
        this.laberInfo = res.data.data;
      });
    },
    // 取消关注
    cancelAttention(id) {
      if (localStorage.getItem("Authorization")) {
        getCancelAttention(id).then(res => {
          this.getAuthor(this.id);
        });
      } else {
        this.loginDialogs = true;
      }
    },
    attention(id) {
      if (localStorage.getItem("Authorization")) {
        getAttention(id).then(res => {
          this.getAuthor(this.id);
        });
      } else {
        this.loginDialogs = true;
      }
    },
    // 文章详情
    articlesDetail(scope) {
      this.$router.push({
        name: "article_detail",
        params: {
          id: scope.id,
          title: scope.title,
          type: this.type,
          isRead: false
        }
      });
    },
    getParentEvent(data) {
      this.loginDialogs = data;
    },
    moreData() {
      this.getAuthorArticle();
    },
    getAuthorArticle() {
      var params = {
        page: this.page,
        per: this.per
      };
      getAuthorArticleList(this.id, params).then(res => {
        this.list = this.list.concat(res.data.data);
        if (this.page >= res.data.meta.total_pages) {
          this.show_page = false;
        } else {
          this.page++;
        }
      });
    }
  },
  created() {
    getTdkList({column:0}).then(res => {
      console.log(res)
      const head = document.getElementsByTagName('head')
      const meta = document.createElement('meta')
      document.title= res.data.data[0].title;
      document.querySelector('meta[name="keywords"]').setAttribute('content',res.data.data[0].keyword)
      document.querySelector('meta[name="description"]').setAttribute('content', res.data.data[0].describe)
      head[0].appendChild(meta)
    })
    
    this.id = this.$route.params.id;
    this.getAuthor(this.id);
    this.getAuthorArticle();
  }
};
</script>
<style lang="scss" scoped>
.breadcrumb {
  color: #999999;
  font-size: 14px;
  line-height: 20px;
  padding-top: 20px;
  padding-bottom: 16px;
  .crumb {
    cursor: pointer;
  }
  span:last-child {
    color: #0091ff;
  }
}
.content-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-bottom: 30px;
  .bigBox {
    display: inline-block;
    width: 48%;
    cursor: pointer;
    .list-box {
      background: #fff;
      margin-bottom: 30px;
      .img {
        width: 100%;
        height: 230px;
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          vertical-align: bottom;
        }
      }
      .suggest {
        padding: 26px 30px 20px 30px;
        p {
          font-size: 20px;
          min-height: 60px;
          line-height: 30px;
          text-overflow: -o-ellipsis-lastline;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          margin-bottom: 12px;
          text-align: justify;
        }
        .message {
          display: flex;
          justify-content: space-between;
          font-size: 14px;
          color: #999999;
          .time {
            margin-right: 24px;
          }
        }
      }
    }
  }
}
.right-box {
  background: #ffffff;
  margin-bottom: 30px;
  .top-laber {
    text-align: center;
    padding: 30px 30px 10px 30px;
    .title {
      font-weight: bold;
    }
    ul {
      text-align: left;
      padding: 0;
      margin-top: 20px;
      display: flex;
      flex-wrap: wrap;
      li {
        list-style-type: none;
        border: 1px solid #0091ff;
        border-radius: 18px;
        padding: 0px 16px;
        color: #0091ff;
        font-size: 16px;
        margin-right: 20px;
        margin-bottom: 20px;
        cursor: pointer;
      }
    }
    .tit {
      font-size: 16px;
      font-weight: bold;
    }
    .laber-info {
      margin-top: 12px;
      padding: 0 30px 20px 30px;
      .img {
        width: 30%;
        display: inline-block;
        margin-top: 10px;
        margin-bottom: 5px;
        img {
          width: 100%;
          border-radius: 50%;
        }
      }
      h4 {
        font-size: 16px;
        line-height: 32px;
        font-weight: 500;
      }
      div {
        font-size: 12px;
        color: #999999;
        margin-bottom: 10px;
      }
      .intro {
        font-size: 14px;
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        cursor: pointer;
      }
      .intro:hover {
        display: block;
      }
      .el-button {
        width: 80px;
        height: 30px;
        padding: 0;
        border-radius: 15px;
        background: #0091ff;
        color: #fff;
      }
      .follow {
        background: #ffffff;
        color: #0091ff;
        border: 1px solid;
      }
      .isActice {
        background: #fff;
        color: #0091ff;
        border: 1px solid;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/authorDetail.vue